<template>
  <router-link v-if="informations.img" to="/">
    <img
      loading="lazy"
      :src="files + informations.img"
      :alt="informations.name"
      class="d-block"
      :height="height"
    />
  </router-link>
</template>

<script>
export default {
  props: {
    height: {
      type: Number,
      default: 83,
    },
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
  },
};
</script>
